import { checkIfTeamExistsAPI } from '@/services';

/* Keep */
export async function checkIfTeamExists(teamName: string, teamId?: string): Promise<boolean> {
  try {
    const teams = await checkIfTeamExistsAPI(teamName, teamId);
    return teams;
  } catch (error) {
    console.log(error);
    throw "Can't find Team";
  }
}
